import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=7c4fb67b&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"
import style0 from "./Detail.vue?vue&type=style&index=0&id=7c4fb67b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4fb67b",
  null
  
)

export default component.exports